import React from 'react';
import { Typography } from '@material-ui/core';
import UserTableBlankBase from './UserTableBlankBase';
import SearchState from '../static/SearchState';
function UserTableAllFilteredState() {
    return (React.createElement(UserTableBlankBase, { image: React.createElement(SearchState, null), message: React.createElement("div", null,
            React.createElement(Typography, { variant: "body1" }, "There were no matching entries")) }));
}
export default UserTableAllFilteredState;
//# sourceMappingURL=UserTableAllFilteredState.js.map